<template>
  <div class="text-darkBlue mb-12">
    <div class="flex flex-wrap justify-between">
      <div class="mt-2">
        <p class="font-semibold text-lg">Password</p>
        <div class="flex justify-between">
          <p class="text-sm">
          The same password strength are enforced for all users across the app.
          <a href="" @click.prevent="showPolicyModal = true"> VIEW POLICY </a>
        </p>
        </div>
      </div>
      <div class="mt-2" >
        <base-button
          text="Update Password"
          background="bg-transparent"
          border="border border-darkBlue"
          @click="showPasswordModal = true"
        />
      </div>
    </div>
    <div v-if="updatePassword" class="my-3 relative">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <label class="label">Current Password</label>
            <base-input
              placeholder="Enter Password"
              v-model="oldPassword"
              type="password"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <label class="label">New Password</label>
            <base-input
              placeholder="Enter New Password"
              type="password"
              v-model="newPassword"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-6 pr-0">
            <label class="label">Confirm New Password</label>
            <base-input
              placeholder="Confirm Password"
              v-model="passwordConfirmation"
              type="password"
              :validation="newPassword == passwordConfirmation"
              errorText="Passwords do not match!"
            />
          </div>
        </div>
      </div>
      <div class="flex justify-end">
        <base-button
          text="Update"
          @click="submit"
          :loading="loading"
          :disabled="disabled"
        />
      </div>

      <div class="my-5 flex justify-between items-center">
        <hr class="w-full" />
        <div class="cursor-pointer" @click="updatePassword = false">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 0C15.53 0 20 4.47 20 10C20 15.53 15.53 20 10 20C4.47 20 0 15.53 0 10C0 4.47 4.47 0 10 0ZM13.59 5L10 8.59L6.41 5L5 6.41L8.59 10L5 13.59L6.41 15L10 11.41L13.59 15L15 13.59L11.41 10L15 6.41L13.59 5Z"
              fill="#0A4269"
            />
          </svg>
        </div>
      </div>
    </div>

    <password-policy-modal :show-modal="showPolicyModal" @close-modal="showPolicyModal = false" />
    <UpdatePasswordModal :show-modal="showPasswordModal" @close-modal="showPasswordModal = false"/>
  </div>
</template>

<script>
import UpdatePasswordModal from "@/views/3pl/Settings/SecurityPolicy/Modals/UpdatePassordModal";
import PasswordPolicyModal from "@/views/3pl/Settings/SecurityPolicy/Modals/PasswordPolicyModal";


export default {
  data() {
    return {
      updatePassword: false,
      oldPassword: "",
      newPassword: "",
      passwordConfirmation: "",
      loading: false,
      showPolicyModal: false,
      
      showPasswordModal: false

    };
  },
  components: { 
    UpdatePasswordModal,
    PasswordPolicyModal
   },
  computed: {
    disabled() {
      if (this.newPassword.length) {
        return this.newPassword != this.passwordConfirmation;
      } else {
        return true;
      }
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      let userId = localStorage.getItem("userId");
      let payload = {
        previousPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.passwordConfirmation,
        userId: userId,
      };
      try {
        await this.$_updatePassword(payload);
        this.generateToast("Password successfully updated", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style></style>
